import React, { Component } from 'react';

export default class Label extends Component {
  render() {
    return (
      <div className="label">
        <b>
          Reset<br />Filters
        </b>
      </div>
    );
  }
}
